(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSitePartRelationship', PublicSitePartRelationship);

    PublicSitePartRelationship.$inject = ['$resource'];

    function PublicSitePartRelationship ($resource) {
        var resourceUrl =  'api/public-site-part-relationships/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
